import '../MyAccountPanels.css'

import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Form, Modal } from 'react-bootstrap'
import Users from './Users'
import { useAuth } from '../../../Providers/AuthProvider';
import LoadingSpinner from '../../Components/LoadingSpinner';
import AddEditUser from './AddEditUser'
import { useUser } from '../../../Providers/UserProvider'
import { useParams } from '../../../Providers/ParamsProvider';

const UsersPanelIndex = () => {
    const { t } = useTranslation();
    const [isAddUserPanelVisible, setIsAddUserPanelVisible] = useState(false);
    const [isLockUnlockPanelVisible, setIsLockUnlockPanelVisible] = useState(false);
    const [handlingUser, setHandlingUser] = useState({ userId: '', userLogin: '', firstName: '', lastName: '', custId: '', phoneNumber: '' })
    const [baseUser, setBaseUser] = useState({ userId: '', userLogin: '', firstName: '', lastName: '', custId: '', phoneNumber: '' })
    const { authState } = useAuth()
    const [isEdit, setIsEdit] = useState(false);
    const [selectedRoles, setSelectedRoles] = useState([])
    const [baseRoles, setBaseRoles] = useState([])
    const [messageBoxMessage, setMessageBoxMessage] = useState("");
    const [buttonBoxTitle, setButtonBoxTitle] = useState("");
    const [userToLockUnlock, setUserToLockUnlock] = useState({ userId: '', isActive: false })
    const { customerUsers, handleGetCustomerUsers, isLoadingUsers, handleGetUserRoles, handleUserLockUnlock, handleSendResetPasswordToUser } = useUser()
    const { isMobile } = useParams()

    const handleCancelLock = () => {
        setIsLockUnlockPanelVisible(false)
    }

    const handleLockUnlockButtonClick = () => {
        setIsLockUnlockPanelVisible(false);
        const value = userToLockUnlock.isActive ? "0" : "1";
        handleUserLockUnlock(value, userToLockUnlock.userId)
    }

    const handleLockUnlock = (user) => {
        setUserToLockUnlock({ userId: user.userId, isActive: user.isActive });
        if (user.isActive) {
            setMessageBoxMessage('Czy na pewno chcesz zablokować użytkownika?')
            setButtonBoxTitle('Zablokuj użytkownika')
        } else {
            setMessageBoxMessage('Czy na pewno chcesz odblokować użytkownika?')
            setButtonBoxTitle('Odblokuj użytkownika')
        }
        setIsLockUnlockPanelVisible(true);
    }

    const handleAddUserButtonClick = () => {
        setIsEdit(false);
        setIsAddUserPanelVisible(true);
    }

    const handleEdit = (user) => {
        setIsEdit(true)
        updateValuesForEdit(user);
        setIsAddUserPanelVisible(true);
    }

    const handleResetPassword = async (user) => {
        handleSendResetPasswordToUser(user.userId)
    }

    const updateValuesForEdit = (user) => {
        const availableRoles = user.roles.map(role => role.roleId);
        setSelectedRoles(availableRoles)
        setBaseRoles(availableRoles)
        setHandlingUser(user);
        setBaseUser(user);
    }

    useEffect(() => {
        if (authState.custId.length > 0) {
            handleGetCustomerUsers()
        }
    }, [authState])

    useEffect(() => {
        handleGetUserRoles()
    }, [])

    return (
        <div>
            <div className='row justify-content-center'>
                <div className='col-12 col-xxl-8 mt-2'>
                    <div className='justify-content-center'>
                        <div className='main-container-holder'>
                            <div className='panel-header-title'>{t("users_panel_navigation")}</div>
                            <AddEditUser
                                isAddUserPanelVisible={isAddUserPanelVisible}
                                setIsAddUserPanelVisible={setIsAddUserPanelVisible}
                                handlingUser={handlingUser}
                                setHandlingUser={setHandlingUser}
                                baseUser={baseUser}
                                setBaseUser={setBaseUser}
                                isEdit={isEdit}
                                selectedRoles={selectedRoles}
                                setSelectedRoles={setSelectedRoles}
                                baseRoles={baseRoles}
                            />
                            <Modal size='md' show={isLockUnlockPanelVisible} onHide={handleCancelLock} centered>
                                <Modal.Header closeButton>
                                    <Modal.Title>Ostrzeżenie</Modal.Title>
                                </Modal.Header>
                                <Modal.Body>
                                    <Form.Label>{messageBoxMessage}</Form.Label> <br />
                                    <button className='btn-app-primary mt-3' onClick={handleLockUnlockButtonClick}>
                                        {buttonBoxTitle}
                                    </button>
                                </Modal.Body>
                            </Modal>
                            <div className='table-responsive'>
                                <table className={`${isMobile ? 'table-font-small' : ''} table table-bordered`}>
                                    <thead>
                                        <tr>
                                            <th style={{ width: '2%', textAlign: 'center', paddingInline: 5 }}>LP</th>
                                            <th style={{ width: '25%' }}>IMIĘ I NAZWISKO</th>
                                            <th style={{ width: '25%' }}>ADRES E-MAIL</th>
                                            <th style={{ width: '22%' }}>NUMER KONTAKTOWY</th>
                                            <th style={{ width: '5%', textAlign: 'center' }}>ADMIN.</th>
                                            <th style={{ width: '5%', textAlign: 'center' }}>ZAM.</th>
                                            <th style={{ width: '5%', textAlign: 'center' }}>OFERTY</th>
                                            <th style={{ width: '5%', textAlign: 'center' }}>FIN.</th>
                                            <th style={{ width: '2%', textAlign: 'center' }}></th>
                                            <th style={{ width: '2%', textAlign: 'center' }}></th>
                                            <th style={{ width: '2%', textAlign: 'center' }}></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {!isLoadingUsers && <Users users={customerUsers} onEdit={handleEdit} onResetPassword={handleResetPassword} onLockUnlock={handleLockUnlock} />}
                                    </tbody>
                                </table>
                                {(customerUsers.length === 0 && customerUsers && !isLoadingUsers) && <div style={{ textAlign: 'center' }}>{t("no_data_users")}</div>}
                            </div>
                            {isLoadingUsers && <LoadingSpinner />}
                            <button className='btn-app-secondary mt-3' onClick={handleAddUserButtonClick}>
                                Dodaj użytkownika
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default UsersPanelIndex